export const EventsConstant = {
  REFRESH_BANK_DETAILS: 'REFRESH_BANK_DETAILS',
  REFRESH_WALLET: 'REFRESH_WALLET',
};

export const validatorKeys = {
  onlyAlphabhets: /^[a-zA-Z ]*$/,
  numbersAndAlphabhets: /^[0-9a-zA-Z ]*$/,
  email: '^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$',
};

export const KYC_REVIEW_STATUS = {
  default: 0,
  init: 1,
  pending: 2,
  preChecked: 3,
  queued: 4,
  completed: 5,
  onHold: 6,
};

export enum KYC_STATUS {
  Pending = 'pending',
  Approved = 'approved',
  Declined = 'declined',
}
